"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceChestDTO = exports.RarityDTO = exports.CivilianDTO = exports.ManualDTO = exports.ItemLootDTO = exports.ResourceLootDTO = exports.ChestDTO = exports.BundleDTO = exports.LootChanceDTO = exports.LootDTO = exports.ChestLootedDTO = exports.ChestChoiceDTO = exports.LootSource = void 0;
var LootSource;
(function (LootSource) {
    LootSource["Owned"] = "Owned";
    LootSource["PlaceAttackPvPVictory"] = "PlaceAttackPvPVictory";
    LootSource["Victory"] = "Victory";
    LootSource["DuringBattle"] = "DuringBattle";
    LootSource["FromChest"] = "FromChest";
})(LootSource = exports.LootSource || (exports.LootSource = {}));
class ChestChoiceDTO {
}
exports.ChestChoiceDTO = ChestChoiceDTO;
class ChestLootedDTO {
}
exports.ChestLootedDTO = ChestLootedDTO;
class LootDTO {
}
exports.LootDTO = LootDTO;
class LootChanceDTO {
}
exports.LootChanceDTO = LootChanceDTO;
class BundleDTO {
}
exports.BundleDTO = BundleDTO;
class ChestDTO {
}
exports.ChestDTO = ChestDTO;
class ResourceLootDTO {
}
exports.ResourceLootDTO = ResourceLootDTO;
class ItemLootDTO {
}
exports.ItemLootDTO = ItemLootDTO;
class ManualDTO {
}
exports.ManualDTO = ManualDTO;
class CivilianDTO {
}
exports.CivilianDTO = CivilianDTO;
class RarityDTO {
}
exports.RarityDTO = RarityDTO;
class PlaceChestDTO {
}
exports.PlaceChestDTO = PlaceChestDTO;
//# sourceMappingURL=Loot.js.map